import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'

interface DialogGuidedLoginProps {
  onCancel?: () => void
  onConfirm?: () => void
  open: boolean
}

export const DialogGuidedLogin = (props: DialogGuidedLoginProps) => {
  const { onCancel, onConfirm, open = false } = props

  return (
    <Dialog open={open} maxWidth={320}>
      <DialogHeader>
        可惜了，您還有服務未使用...
      </DialogHeader>
      <DialogContent>
        <Text variant="body" align="center">加入品牌會員，即能享「追蹤貨態、查詢訂單」各種官網服務</Text>
      </DialogContent>
      <DialogActions>
        <Button fullWidth color="grey" variant="outlined" onClick={onCancel}>忍痛放棄</Button>
        <Button fullWidth color="primary" onClick={onConfirm}>登入會員</Button>
      </DialogActions>
    </Dialog>
  )
}
